{
  "version": 1,
  "asset_id": "c0171c6b-ad05-4b28-9ad7-8b2b2a162cf5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/c0171c6b-ad05-4b28-9ad7-8b2b2a162cf5/reflux-stomach-before.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/c0171c6b-ad05-4b28-9ad7-8b2b2a162cf5/reflux-stomach-before.webp",
  "original_filename": "reflux-stomach-before.webp",
  "size": 23734,
  "content_type": "image/webp",
  "created_at": "2026-09-13T20:58:48Z"
}
